import { render, staticRenderFns } from "./ScientistPublications.vue?vue&type=template&id=2e368b36&scoped=true&"
import script from "./ScientistPublications.vue?vue&type=script&lang=js&"
export * from "./ScientistPublications.vue?vue&type=script&lang=js&"
import style0 from "./ScientistPublications.vue?vue&type=style&index=0&id=2e368b36&lang=scss&scoped=true&"
import style1 from "./ScientistPublications.vue?vue&type=style&index=1&id=2e368b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e368b36",
  null
  
)

export default component.exports